export default "__VITE_ASSET__BdunZ5y5__"